import React from 'react';

import { SVGPropsType } from 'src/types';

function ArrowDown(props: SVGPropsType) {
    const { stroke, onClick, style, className } = props;

    return (
        <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M15 8.5L10 13.5L5 8.5"
                stroke={stroke}
                strokeWidth="1.67"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default ArrowDown;
